<template>
  <div style="margin-bottom:20px;">
    <div>
        <div class="title-box">{{deptDuty.deptName}}</div>
        <div class="content-box">
          <span class="content-item" v-for="item in serviceList" :key="item.id" :value="item.id">
            <span @click="handleClick(item)">{{item.urlName}}</span>
          </span>
        </div>
        <div class="foot-border"><!-- More --></div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    deptDuty: {
      type: Object,
      require: true
    }
  },
  data() {
    return {
      serviceList: []
    }
  },
  methods: {
    loadServiceList () {
      this.$api.index.getMinisterCenter({
          modularId: this.deptDuty.id,
          pageNum: 1,
          pageSize: 8
        }).then(res => {
          if (res.code === 200) {
            res.data.content.forEach(item => {
              if (item.createTime) {
                item.time = item.createTime.replace("T", " ").substr(0, item.createTime.indexOf("."))
              }
            })
            this.serviceList = res.data.content
          } else {
            this.$message.error(res.message)
          }
      });
    },
    handleClick(item) {
      if (item.url) {
        const a = document.createElement("a");
        let url = "";
        if (item.url.indexOf("http") !== -1) {
          url = item.url;
        } else {
          url = "http://" + item.url;
        }
        a.setAttribute("href", url);
        a.setAttribute("target", "_blank");
        a.click();
      }
    }
  },
  mounted() {
      this.loadServiceList()
  },
}
</script>

<style scoped lang='less'>
.title-box{
    width:316px;
    height:58px;
    line-height:58px;
    text-align:center;
    color:#fff;
    background: #650004;
}
.content-box{
    width:316px;
    height:119px;
    background: #FFF8F8;
    padding: 10px;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: space-between;
}
.content-item{
  width: 50%;
  text-align: center;
  padding-top: 5px;
  padding-bottom: 5px;
  cursor: pointer;
}
.foot-border{
    width:316px;
    height:24px;
    background: #FFF8F8;
    text-align:center;
    font-size:14px;
    padding:5px 0;
    border-bottom:2px solid #650004;
    color: #650004;
}
</style>
